var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.571,
    height: 20,
    viewBox: "0 0 28.571 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_user-friends",
    "data-name": "solid user-friends",
    d: "M8.571,42a5,5,0,1,0-5-5A5,5,0,0,0,8.571,42ZM12,43.429h-.371a6.9,6.9,0,0,1-6.116,0H5.143A5.144,5.144,0,0,0,0,48.571v1.286A2.143,2.143,0,0,0,2.143,52H15a2.143,2.143,0,0,0,2.143-2.143V48.571A5.144,5.144,0,0,0,12,43.429ZM21.429,42a4.286,4.286,0,1,0-4.286-4.286A4.287,4.287,0,0,0,21.429,42Zm2.143,1.429H23.4a5.63,5.63,0,0,1-3.946,0h-.17a4.958,4.958,0,0,0-2.487.688,6.533,6.533,0,0,1,1.772,4.455v1.714c0,.1-.022.192-.027.286h7.884a2.143,2.143,0,0,0,2.143-2.143A5,5,0,0,0,23.571,43.429Z",
    transform: "translate(0 -32)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employees-icon.f0f0abb2e56e29590a204e35234ec1a0.svg";
export { ForwardRef as ReactComponent };